import type { CoreApiClient } from "../client";
import { createGeocodingQueries } from "../queries/geocoding.queries";

export const createGeocodingRepository = (api: CoreApiClient) => ({
  ...createGeocodingQueries(api),
});
